import React, { useCallback, useEffect, useMemo, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import DetailsVideo from '../../video/details-video'
import { useRef } from 'react'
import _ from 'lodash'

const VideoItem = props => {
    useStyles(classes)
    const { position, addPlayingVideo, removePlayingVideo, clickHandle } = props
    const liRef = useRef(null)
    const [isInView, setIsInView] = useState(false)

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsInView(true)
                    } else {
                        setIsInView(false)
                    }
                })
            },
            { threshold: 1 } // 完全在视窗中才触发
        )

        if (liRef.current) {
            observer.observe(liRef.current)
        }

        return () => {
            if (liRef.current) {
                observer.unobserve(liRef.current)
            }
        }
    }, [])

    useEffect(() => {
        if (isInView) {
            addPlayingVideo(position)
        } else {
            removePlayingVideo(position)
        }
    }, [isInView])

    return <li ref={liRef} className={classes.VideoSwiperSlide}>
        <DetailsVideo {...props} />
    </li>
}


export default props => {
    useStyles(classes)
    const { videos, listVideoClickHandle } = props
    const [muted, setMuted] = useState(true)
    const [playingIndex, setPlayingIndex] = useState(-1)
    const [playingVideos, setPlayingVideos] = useState([])
    const leftVideos = useRef([])

    const debouncedUpdateValue = useCallback(_.debounce((playingVideos) => {
        console.log('检测到播放列表', playingVideos)
        leftVideos.current = [...playingVideos].sort((a, b) => a - b)
        setPlayingIndex(leftVideos.current.shift())
    }, 500), [])

    const endedHandle = () => {
        if (leftVideos.current) {
            setPlayingIndex(leftVideos.current.shift())
        } else {
            setPlayingIndex(-1)
        }
    }

    const addPlayingVideoHandle = index => {
        setPlayingVideos([...playingVideos, index])
        console.log(`add index ${index}`)
    }

    const removePlayingVideoHandle = index => {
        setPlayingVideos(playingVideos.filter(i => i !== index))
        console.log(`remove index ${index}`)
    }


    useEffect(() => {
        debouncedUpdateValue(playingVideos)
    }, [playingVideos])


    return <ul className={`${classes.VideoList}`}>
        {
            videos?.map((video, index) => {
                return <VideoItem clickHandle={() => listVideoClickHandle(index, video)} key={video.youtubeId || index} removePlayingVideo={removePlayingVideoHandle} addPlayingVideo={addPlayingVideoHandle} position={index} setMuted={setMuted} muted={muted} video={video} endedHandle={endedHandle} shouldPlay={playingIndex === index} />
            })
        }
    </ul>
}